import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { AlertsDataProviderFactory } from '../factory/AlertsDataProviderFactory';
import { AlertsBaseDataProvider } from '../dataProvider/AlertsBaseDataProvider';
import {
  CreateViewRequest,
  CreateViewResponse,
  DeleteViewRequest,
  DeleteViewResponse,
  InitAlertsRequest,
  UpdateActiveViewRequest,
  UpdateActiveViewResponse,
  UpdateSmartViewsStateResponse,
  UpdateSmartViewsStateRequest,
  UpdateViewPropsRequest,
  UpdateViewPropsResponse,
  ValidateViewNameRequest,
  ValidateViewNameResponse,
} from '@nirvana/shared/dtos/types/alerts/gz-console';
import {
  GetAllColumnDetailsRequest,
  GetAllColumnDetailsResponse,
  InitAlertsResponse,
} from '@nirvana/shared/dtos/types/alerts/common';

export class AlertsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AlertsDataProviderFactory;
  public dataProvider: AlertsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new AlertsDataProviderFactory(),
    });
  }

  async initAlerts(params: InitAlertsRequest): Promise<InitAlertsResponse> {
    return this.dataProvider.initAlerts(params);
  }

  async getAllColumnDetails(params: GetAllColumnDetailsRequest): Promise<GetAllColumnDetailsResponse> {
    return this.dataProvider.getAllColumnDetails(params);
  }

  async deleteView(params: DeleteViewRequest): Promise<DeleteViewResponse> {
    return this.dataProvider.deleteView(params);
  }

  public async createView(params: CreateViewRequest): Promise<CreateViewResponse> {
    return this.dataProvider.createView(params);
  }

  public async updateActiveView(params: UpdateActiveViewRequest): Promise<UpdateActiveViewResponse> {
    return this.dataProvider.updateActiveView(params);
  }

  public async updateViewProps(params: UpdateViewPropsRequest): Promise<UpdateViewPropsResponse> {
    return this.dataProvider.updateViewProps(params);
  }

  public validateViewName(params: ValidateViewNameRequest): Promise<ValidateViewNameResponse> {
    return this.dataProvider.validateViewName(params);
  }

  public updateSmartViewsState(params: UpdateSmartViewsStateRequest): Promise<UpdateSmartViewsStateResponse> {
    return this.dataProvider.updateSmartViewsState(params);
  }
}
